import React, {ChangeEvent, useRef, useState} from "react";
import {indexWrapCss} from "../css/Goods.style";
import Header from "../../../common/layouts/header/Header";
import Footer from "../../../common/layouts/footer/Footer";
import Modal from "react-modal";
import ImageCrop from "../../author/ImageCrop";
import {addPostCard} from "../../../api/index";
import Alert from "../../../common/layouts/modal/Alert";
import PostCardList from "../PostCardList";
import {useNavigate} from "react-router-dom";

interface AddGoodsProps {
    postCardList: any;
    isMobile: boolean;
    onDelete: (id: number) => void;
    onUpdate : (id : number , msg : string) => void;
    currentPage : number,
    totalPages : number,
    onPageChange: (newPage: number) => void;
}


const AddGoodsMobile = ({ postCardList, isMobile, onDelete, onUpdate , currentPage, totalPages,onPageChange  }: AddGoodsProps) => {

    const navigate = useNavigate();

    const [search, setSearch] = useState<any>([]);
    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };
    const [postCardPreview, setPostCardPreview] = useState<string | undefined>(undefined);
    const [postCard, setPostCard] = useState<string | undefined>(undefined);
    const postCardRef = useRef<HTMLInputElement | null>(null);
    const [errors, setErrors] = useState<{ img?: string }>({});
    const [showImageCrop, setShowImageCrop] = useState(false);
    const [postCardText, setPostCardText] = useState<string>("");
    const [showAlert, setShowAlert] = useState(false);

    const [image, setImage] = useState<string | null>(null);

    const closeModal = () => {
        setShowImageCrop(false);
    };

    const handleCrop = (cropData: string) => {

        setPostCardPreview(cropData);

        closeModal();
    };

    const blobToFile = (blob: Blob, fileName: string): File => {
        return new File([blob], fileName, { type: blob.type });
    };

    const base64ToBlob = (base64: string, contentType: string): Blob => {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    };

    const formData = new FormData();
    formData.append('postCardContent', postCardText);

    if (postCardPreview) {
        const blob = base64ToBlob(postCardPreview, 'image/png');
        const file = blobToFile(blob, 'postCardPhoto.png');
        formData.append('postCardPhoto', file);
    }



    const handleAddPostcard = async () => {
        if (!postCardPreview) {
            setErrors({ img: '*이미지를 업로드 해주세요.' });
            return;
        }

        try {
            await addPostCard(formData).then(r => {
                    console.log("엽서 등록 성공!");

                    setShowAlert(true);


                }
            );

        } catch (error) {
            console.error("엽서 등록 실패", error);
        }

    };


    const openModal = () => {
        setShowImageCrop(true);
    };


    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file ) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setImage(reader.result as string);
            openModal();
            /*
            if (typeof reader.result === 'string') {
                const base64String = reader.result;

                const base64Data = base64String.split(',')[1];

                const blob = base64ToBlob(base64Data, file.type);

                const previewUrl = URL.createObjectURL(blob);

                setPostCard(base64String);
                setPostCardPreview(previewUrl);
            }*/
        };
        reader.readAsDataURL(file);

    };





    return <>

        <div css={indexWrapCss}>
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag=""
            />

            {/* 모바일 히어로 */}
            <div style={{ background: 'linear-gradient(180deg, #e8f8f0 0%, #edf9f3 40%, #fafafa 100%)' }}
                 className="w-full pt-8 pb-10 px-4">
                <div className="flex flex-col items-center text-center gap-2">
                    <span className="inline-flex items-center gap-1.5 bg-white border border-[#baecd4] text-[#19cf7a] text-[12px] font-semibold px-3 py-1 rounded-full shadow-sm">
                        🖼️ 엽서 추가
                    </span>
                    <h1 className="font-bold text-[#222] leading-tight text-[22px]">
                        작품과 함께할 <span className="text-[#19cf7a]">엽서</span>를 추가해 보세요
                    </h1>
                    <p className="text-[#888] text-[13px]">독자들에게 특별한 엽서를 선물해 보세요</p>
                </div>
            </div>

            <div className="flex flex-col px-4 gap-6 py-8 w-full min-w-[380px]">
                {/* 이미지 업로드 */}
                <div className="bg-white rounded-2xl border border-[#f0f0f0] shadow-sm p-5 flex flex-col gap-4 items-center">
                    <div
                        id="img-preview"
                        className="w-[155px] h-[219px] rounded-xl overflow-hidden border border-[#e8f8f0] bg-[#f9fdfa] flex items-center justify-center"
                    >
                        {postCardPreview ? (
                            <img
                                className="w-full h-full object-cover"
                                src={postCardPreview}
                                alt="엽서 미리보기"
                            />
                        ) : (
                            <div className="flex flex-col items-center gap-2 text-[#ccc]">
                                <span className="text-3xl">🖼️</span>
                                <span className="text-[11px]">이미지 선택</span>
                            </div>
                        )}
                    </div>

                    <button
                        className="relative w-full h-11 text-[14px] font-semibold rounded-full bg-white text-[#19cf7a] border border-[#19cf7a] flex items-center justify-center"
                        type="button"
                    >
                        <input
                            ref={postCardRef}
                            className="absolute top-0 left-0 opacity-0 w-full h-full cursor-pointer"
                            type="file"
                            id="backgroundFileInput"
                            accept="image/*"
                            onChange={handleFileChange}
                        />
                        이미지 선택
                    </button>
                    <span className="text-[#aaa] text-[12px]">*최대 1MB까지 업로드 가능</span>
                </div>

                <Modal
                    isOpen={showImageCrop}
                    shouldCloseOnOverlayClick={false}
                    onRequestClose={closeModal}
                    contentLabel="imageCrop Modal"
                    className="modal-login"
                    ariaHideApp={false}
                    overlayClassName="overlay">
                    {image && (
                        <ImageCrop
                            image={image}
                            onClose={closeModal}
                            onCrop={handleCrop}
                        />
                    )}
                </Modal>

                {/* 텍스트 입력 */}
                <div className="bg-white rounded-2xl border border-[#f0f0f0] shadow-sm p-5 flex flex-col gap-3">
                    <label className="text-[#444] text-[14px] font-semibold">엽서 설명</label>
                    <textarea
                        className="w-full h-[130px] border border-[#e8f8f0] bg-[#f9fdfa] p-4 rounded-xl resize-none font-namsan text-[14px] focus:outline-none focus:border-[#19cf7a] transition-all placeholder:text-[#ccc]"
                        value={postCardText}
                        maxLength={200}
                        placeholder='엽서에 담긴 소중한 이야기를 들려주세요 (최대 200자)'
                        onChange={(e) => setPostCardText(e.target.value)}
                    />
                    <div className="flex justify-end">
                        <span className="text-[#aaa] text-[12px]">{postCardText.length}/200</span>
                    </div>

                    {errors.img && (
                        <p className="text-red-500 font-semibold text-[13px]">{errors.img}</p>
                    )}

                    <button
                        className="w-full h-[50px] rounded-full bg-[#19cf7a] text-white font-bold text-[15px] hover:bg-[#00b368] shadow-[0px_4px_6px_rgba(25,207,122,0.2)] transition-colors"
                        onClick={handleAddPostcard}
                        type="button"
                    >
                        엽서 추가하기
                    </button>
                </div>

                {/* 등록된 엽서 목록 */}
                <div className="bg-white rounded-2xl border border-[#f0f0f0] shadow-sm p-5">
                    <h2 className="text-[#222] text-[16px] font-bold mb-4">등록된 엽서 목록</h2>
                    <PostCardList postCardList={postCardList} onDelete={onDelete} onUpdate={onUpdate} currentPage={currentPage}
                                  totalPages={totalPages}
                                  onPageChange={onPageChange}/>
                </div>
            </div>


            {showAlert && (
                <Alert
                    title=""
                    message="엽서가 등록되었습니다."
                    onClose={() => {
                        setShowAlert(false)
                        navigate(0);
                    }
                    }
                />
            )}

            {/* 엽서 등록 contents 영역*/}



            <Footer/>
        </div>


    </>


}

export default AddGoodsMobile;
